exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal{@apply(--reset-container);@apply(--reset-base);@apply(--reset-box-model);@apply(--reset-font);overflow:hidden;background-color:var(--modal-background-color);position:absolute;left:0;right:0;top:0;bottom:0;width:100%;height:100%;display:table;z-index:2147483647}.modal__content{@apply(--reset-container);@apply(--reset-base);@apply(--reset-box-model);@apply(--reset-font);display:table-cell;vertical-align:middle;text-align:center;color:var(--modal-text-color);white-space:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/onsenui/css-components-src/src/components/modal.css
// module id = 345
// module chunks = 1